module.exports = __webpack_public_path__ + "static/media/Ubuntu-Regular.12626a0b.woff2";